/**
 * Short vanity URL for the hiatal hernia repair page.
 * Redirects to the canonical /services/hiatal-hernia-surgery route and is
 * intentionally excluded from the sitemap (redirect target only).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/hiatal")({
  beforeLoad: () => {
    throw redirect({ to: "/services/hiatal-hernia-surgery", statusCode: 301, replace: true });
  },
});
